import styled from "styled-components";

import {
    A,
    P,
    H2,
    BorderBottomLinkStyle,
    CustomFocusStyle
} from "core/Typography";
import colors from "core/colors";
import { textSm } from "core/fontStyles";
import { rapidEasing } from "core/animation";
import { convertPxToRem } from "frontend/components/helpers";

import Flexbox from "core/Flexbox";
import Info from "core/ReusableIcons/Info";

export const Link = styled(A)`
    ${BorderBottomLinkStyle}
    color: ${colors.accent.darkMode.suenosBuenos};
    border-color: ${colors.accent.darkMode.suenosBuenos};
    transition: color ${rapidEasing}, border-bottom-color ${rapidEasing};
    &:hover {
        color: ${colors.primary.diamond};
        border-color: ${colors.primary.diamond};
    }
    ${CustomFocusStyle}
`;

export const Wrapper = styled.div`
    margin-top: ${convertPxToRem({ px: 24 })};

    ${H2} {
        margin-bottom: ${convertPxToRem({ px: 8 })};
        color: ${colors.primary.diamond};
    }
`;

// AttributionInstructions

export const DisclaimerText = styled.span`
    margin-right: ${convertPxToRem({ px: 8 })};
    display: inline-block;
`;

export const IconButton = styled.button`
    cursor: pointer;
    border: 0;
    padding: 0;
    background-color: transparent;
`;

export const InfoIcon = styled(Info).attrs({
    fillColor: colors.accent.darkMode.suenosBuenos,
    size: "md"
})``;

export const Instructions = styled(P)`
    color: ${colors.secondary.dolphin};
`;

export const InstructionsList = styled.ul`
    color: ${colors.secondary.dolphin};
    ${textSm}

    li {
        list-style: disc;
        margin-left: ${convertPxToRem({ px: 12 })};
    }
`;

// AttributionText

export const StyledAttributionText = styled(Flexbox)`
    width: 100%;
    background-color: ${colors.primary.snow};
    padding: ${convertPxToRem({ px: 11 })} ${convertPxToRem({ px: 13 })};

    textarea {
        width: 100%;
        padding: 0;
        font-family: inherit;
        color: ${colors.secondary.orca};
        font-size: ${convertPxToRem({ px: 12 })};
        line-height: ${convertPxToRem({ px: 16 })};
        resize: none;
        user-select: all;
        border: none;
        margin-right: ${convertPxToRem({ px: 16 })};
        ${CustomFocusStyle}
    }
`;
